const HOTJAR = '_blHjAgr';
const ANALYTICS = '_blGAAgr';

export default Object.freeze({
  HOTJAR,
  ANALYTICS,
  USER_GLOBAL_AGREEMENT: '_blGlobAgr',
  AGREEMENTS: [HOTJAR, ANALYTICS]
});
